module.exports = __webpack_public_path__ + "static/media/more_option_dots.de31951c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/more_option_dots.svg
// module id = 491
// module chunks = 0